import {
  DevelopmentClient,
  IDevelopmentClient,
} from '@app/models/DevelopmentClient'
import { List, Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface IDevelopmentSiteMetadataResponse {
  readonly success: boolean
  readonly cities: List<string>
  readonly clients: List<IDevelopmentClient>
}

const DevelopmentSiteMetadataResponseRecord = Record({
  cities: List<string>(),
  clients: List<DevelopmentClient>(),
  success: true,
})

export class DevelopmentSiteMetadataResponse
  extends DevelopmentSiteMetadataResponseRecord
  implements IDevelopmentSiteMetadataResponse {
  public static fromJS(
    initialState?: Partial<IDevelopmentSiteMetadataResponse>,
  ) {
    if (!initialState) {
      return new DevelopmentSiteMetadataResponse()
    }

    const { cities, clients, ...rest } = initialState

    return new DevelopmentSiteMetadataResponse({
      cities: List(cities || []),
      clients: clients
        ? List(clients.map((a) => DevelopmentClient.fromJS(a)))
        : undefined,
      ...rest,
    })
  }

  public readonly success: boolean
  public readonly cities: List<string>
  public readonly clients: List<DevelopmentClient>

  constructor(initialState?: Partial<DevelopmentSiteMetadataResponse>) {
    initialState ? super(initialState) : super()
  }
}
